import styles from './ShowMoreLessButton.module.scss';

interface ShowMoreLessButtonProps {
    onClick: () => void;
    showMore: boolean;
}

export default function ShowMoreLessButton({ onClick, showMore }: ShowMoreLessButtonProps) {
    return (
        <button className={styles.toggleButton} onClick={onClick}>
            {showMore ? 'Show less' : 'Show all'}
            <span className={styles.toggleIcon}>{showMore ? '−' : '+'}</span>
        </button>
    );
}

